<template>
    <div class="node">
        <div class="placeholder"></div>
        <div class="node-bg"></div>
        <div class="node-swipe">
            <Swipe class="swipe" :autoplay="3000" indicator-color="white">
                <SwipeItem>
                    <div class="swipe-item">
                        <img src="../../assets/img/node/swipe1.png" alt="" />
                    </div>
                </SwipeItem>
            </Swipe>
        </div>
        <div class="tags">
            <!-- <div :class="{ active: tabActive == 1 }" @click="tabActive = 1">{{ $t('node.ecology') }}</div> -->
        </div>
        <div >

                    <div class="card1" >
                        <div>
                            <div class="card1-title">
                            {{$t('node.release1') }}
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{KOLWD}} YUX</div>
                                        <div class="value"> {{ $t('node.totalCollection') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{KOLWaitWD}} YUX</div>
                                        <div class="value"> {{ $t('node.toBeClaimed') }}</div>
                                    </div>

                                    <div>
                                        <div class="btn" @click="getWDReward(1)">{{ $t('node.claimed') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{KOLTotal}} YUX</div>
                                        <div class="value">{{ $t('node.totalRelease') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{KOLWD + KOLWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.released') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{KOLTotal - KOLWD - KOLWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.toBeReleased') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="card1" v-if="false" >
                        <div>
                            <div class="card1-title">
                            {{$t('node.release2') }}
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{AirdropWD}} YUX</div>
                                        <div class="value"> {{ $t('node.totalCollection') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{AirdropWaitWD}} YUX</div>
                                        <div class="value"> {{ $t('node.toBeClaimed') }}</div>
                                    </div>

                                    <div>
                                        <div class="btn" @click="getWDReward(2)">{{ $t('node.claimed') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{AirdropTotal}} YUX</div>
                                        <div class="value">{{ $t('node.totalRelease') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{AirdropWD + AirdropWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.released') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{AirdropTotal - AirdropWD - AirdropWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.toBeReleased') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>

<div class="card1" >
                        <div>
                            <div class="card1-title">
                            {{$t('node.release3') }}
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{LiquidityWD}} YUX</div>
                                        <div class="value"> {{ $t('node.totalCollection') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{LiquidityWaitWD}} YUX</div>
                                        <div class="value"> {{ $t('node.toBeClaimed') }}</div>
                                    </div>

                                    <div>
                                        <div class="btn" @click="getWDReward(3)">{{ $t('node.claimed') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{LiquidityTotal}} YUX</div>
                                        <div class="value">{{ $t('node.totalRelease') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{LiquidityWD + LiquidityWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.released') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{LiquidityTotal - LiquidityWD - LiquidityWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.toBeReleased') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card1" >
                        <div>
                            <div class="card1-title">
                            {{$t('node.release4') }}
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{TeamFundWD}} YUX</div>
                                        <div class="value"> {{ $t('node.totalCollection') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{TeamFundWaitWD}} YUX</div>
                                        <div class="value"> {{ $t('node.toBeClaimed') }}</div>
                                    </div>

                                    <div>
                                        <div class="btn" @click="getWDReward(4)">{{ $t('node.claimed') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{TeamFundTotal}} YUX</div>
                                        <div class="value">{{ $t('node.totalRelease') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{TeamFundWD + TeamFundWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.released') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{TeamFundTotal - TeamFundWD - TeamFundWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.toBeReleased') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>

 <div class="card1" >
                        <div>
                            <div class="card1-title">
                            {{$t('node.release5') }}
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{EcoFundWD}} YUX</div>
                                        <div class="value"> {{ $t('node.totalCollection') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{EcoFundWaitWD}} YUX</div>
                                        <div class="value"> {{ $t('node.toBeClaimed') }}</div>
                                    </div>

                                    <div>
                                        <div class="btn" @click="getWDReward(5)">{{ $t('node.claimed') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{EcoFundTotal}} YUX</div>
                                        <div class="value">{{ $t('node.totalRelease') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{EcoFundWD + EcoFundWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.released') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{EcoFundTotal - EcoFundWD - EcoFundWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.toBeReleased') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>
                     <div class="card1" >
                        <div>
                            <div class="card1-title">
                            {{$t('node.release6') }}
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{InvestmentWD}} YUX</div>
                                        <div class="value"> {{ $t('node.totalCollection') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{InvestmentWaitWD}} YUX</div>
                                        <div class="value"> {{ $t('node.toBeClaimed') }}</div>
                                    </div>

                                    <div>
                                        <div class="btn" @click="getWDReward(6)">{{ $t('node.claimed') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{InvestmentTotal}} YUX</div>
                                        <div class="value">{{ $t('node.totalRelease') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{InvestmentWD + InvestmentWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.released') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{InvestmentTotal - InvestmentWD - InvestmentWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.toBeReleased') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>

  <div class="card1" >
                        <div>
                            <div class="card1-title">
                            {{$t('node.release7') }}
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{NodeWD}} YUX</div>
                                        <div class="value"> {{ $t('node.totalCollection') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{NodeWaitWD}} YUX</div>
                                        <div class="value"> {{ $t('node.toBeClaimed') }}</div>
                                    </div>

                                    <div>
                                        <div class="btn" @click="getWDReward(7)">{{ $t('node.claimed') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{NodeTotal}} YUX</div>
                                        <div class="value">{{ $t('node.totalRelease') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{NodeWD + NodeWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.released') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{NodeTotal - NodeWD - NodeWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.toBeReleased') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>
  <div class="card1"  v-if="false">
                        <div>
                            <div class="card1-title">
                            {{$t('node.release8') }}
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{MiningWD}} YUX</div>
                                        <div class="value"> {{ $t('node.totalCollection') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{MiningWaitWD}} YUX</div>
                                        <div class="value"> {{ $t('node.toBeClaimed') }}</div>
                                    </div>

                                    <div>
                                        <div class="btn" @click="getWDReward(8)">{{ $t('node.claimed') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{MiningTotal}} YUX</div>
                                        <div class="value">{{ $t('node.totalRelease') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{MiningWD + MiningWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.released') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{MiningTotal - MiningWD - MiningWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.toBeReleased') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>

 <div class="card1" >
                        <div>
                            <div class="card1-title">
                            {{$t('node.release9') }}
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{StakingWD}} YUX</div>
                                        <div class="value"> {{ $t('node.totalCollection') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{StakingWaitWD}} YUX</div>
                                        <div class="value"> {{ $t('node.toBeClaimed') }}</div>
                                    </div>

                                    <div>
                                        <div class="btn" @click="getWDReward(9)">{{ $t('node.claimed') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{StakingTotal}} YUX</div>
                                        <div class="value">{{ $t('node.totalRelease') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{StakingWD + StakingWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.released') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{StakingTotal - StakingWD - StakingWaitWD}} YUX</div>
                                        <div class="value">{{ $t('node.toBeReleased') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>

<!-- --- -->
        </div>
        <!-- 节点认购 -->
           <Popup v-model="subscriptionShow" position="bottom" round get-container="#app">
           
            <div class="subscription-claim" >
                <div class="title">
                    {{ $t('node.executionSuccessful') }}
                    <img src="../../assets/img/node/icon7.png" @click="subscriptionShow = false" alt="">
                </div>
                <div class="claim-ok">
                    <img src="../../assets/img/node/claim.png" alt="">
                    <div class="title">
                        {{ $t('node.executionSuccessful') }}
                    </div>
                </div>

            </div>
        </Popup>

    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";

import axios from 'axios'
import Web3 from 'web3'
import contractaa from '../contract/index.js'
let web3
web3 = new Web3(window.ethereum)

export default {
    name: "node",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "100",
            tabActive: 1,
            release: 2,
            empty: false,
            show: false,
            claimOk: false,
            loading: false,


            subscriptionLoading: false,
            subscriptionShow: false,
            subscriptionOk: false,
            //KOL 激励
            //总量
            KOLTotal:0,
            //待领取
            KOLWaitWD:0,
            //已经领取
            KOLWD:0,

            //全球空投
            AirdropTotal:0,
            AirdropWaitWD:0,
            AirdropWD:0,

            //流动性池
            LiquidityTotal:0,
            LiquidityWaitWD:0,
            LiquidityWD:0,

            //创始团队
            TeamFundTotal:0,
            TeamFundWaitWD:0,
            TeamFundWD:0,

            //生态基金
            EcoFundTotal:0,
            EcoFundWaitWD:0,
            EcoFundWD:0,

            //机构
            InvestmentTotal:0,
            InvestmentWaitWD:0,
            InvestmentWD:0,

            //全球节点
            NodeTotal:0,
            NodeWaitWD:0,
            NodeWD:0,

            //生态矿池
            MiningTotal:0,
            MiningWaitWD:0,
            MiningWD:0,

            //质押矿池
            StakingTotal:0,
            StakingWaitWD:0,
            StakingWD:0,
        };
    },
    computed: {
         getNodeName(){
            return(v)=>{
                if(v==0){
                    return this.$t('node.node0')
                }else if(v==1){
                    return this.$t('node.node1')
                }else if(v==2){
                    return this.$t('node.node2')
                }else if(v==3){
                    return this.$t('node.node3')
                }else if(v==4){
                    return this.$t('node.node4')
                }else if(v==5){
                    return this.$t('node.node5')
                }
                
            }
        }
    },
    methods: {
        handleClaim() {
            this.loading = true;
            setTimeout(() => {
                this.claimOk = true;
                this.loading = false;

            }, 2000)
        },
        onClose() {
            this.loading = false;
            this.claimOk = false;
            this.show = false;

        },

        dobuyNode(){
            this.tabActive=1
        },
        getImg(v){
            if(v==0){
               return require('../../assets/img/node/node1.png')
            }else if(v==1){
                return require('../../assets/img/node/node2.png')
            }else if(v==2){
                return require('../../assets/img/node/node3.png')
            }else if(v==3){
                return require('../../assets/img/node/node4.png')
            }else if(v==4){
                return require('../../assets/img/node/node5.png')
            }else if(v==5){
                return require('../../assets/img/node/node6.png')
            }
        },
        async getWDReward(v){
           
            let that = this;

            let address = this.$store.state.globalAddress;
            var KOLContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.KOLToken);
            //var AirdropContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.AirdropToken);
            var LiquidityContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.LiquidityToken);
            var TeamFundContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.TeamFundToken);
            var EcoFundContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.EcoFundToken);
            var InvestmentContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.InvestmentToken);
            var NodeContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.NodeReleaseToken);
           // var MiningContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.MiningToken);
            var StakingContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.StakingToken);

           
            this.$store.commit('handleShow', true)
            if(v == 1){
                const receipt = await KOLContract.methods.wdReward().send({from:address})
                    if(receipt.status == "1"){
                        that.$store.commit('handleLoading', false)
                        that.getInfo();
                    }else{
                        that.$toast.fail(that.$t('node.error'));
                    }
            }
            // else if(v == 2){
            //     const receipt = await AirdropContract.methods.wdReward().send({from:address})
            //         if(receipt.status == "1"){
            //             that.$store.commit('handleLoading', false)
            //             that.getInfo();
            //         }else{
            //             that.$toast.fail(that.$t('node.error'));
            //         }
            // }
            else if(v == 3){
                const receipt = await LiquidityContract.methods.wdReward().send({from:address})
                    if(receipt.status == "1"){
                        that.$store.commit('handleLoading', false)
                        that.getInfo();
                    }else{
                        that.$toast.fail(that.$t('node.error'));
                    }
            }else if(v == 4){
                const receipt = await TeamFundContract.methods.wdReward().send({from:address})
                    if(receipt.status == "1"){
                        that.$store.commit('handleLoading', false)
                        that.getInfo();
                    }else{
                        that.$toast.fail(that.$t('node.error'));
                    }
            }else if(v == 5){
                const receipt = await EcoFundContract.methods.wdReward().send({from:address})
                    if(receipt.status == "1"){
                        that.$store.commit('handleLoading', false)
                        that.getInfo();
                    }else{
                        that.$toast.fail(that.$t('node.error'));
                    }
            }else if(v == 6){
                const receipt = await InvestmentContract.methods.wdReward().send({from:address})
                    if(receipt.status == "1"){
                        that.$store.commit('handleLoading', false)
                        that.getInfo();
                    }else{
                        that.$toast.fail(that.$t('node.error'));
                    }
            }else if(v == 7){
                const receipt = await NodeContract.methods.wdReward().send({from:address})
                    if(receipt.status == "1"){
                        that.$store.commit('handleLoading', false)
                        that.getInfo();
                    }else{
                        that.$toast.fail(that.$t('node.error'));
                    }
            }
            // else if(v == 8){
            //     const receipt = await MiningContract.methods.wdReward().send({from:address})
            //         if(receipt.status == "1"){
            //             that.$store.commit('handleLoading', false)
            //             that.getInfo();
            //         }else{
            //             that.$toast.fail(that.$t('node.error'));
            //         }
            // }
            else if(v == 9){
                const receipt = await StakingContract.methods.wdReward().send({from:address})
                    if(receipt.status == "1"){
                        that.$store.commit('handleLoading', false)
                        that.getInfo();
                    }else{
                        that.$toast.fail(that.$t('node.error'));
                    }
            }
            
        },

        async getInfo(){
            let that = this;
            let address = this.$store.state.globalAddress;
            var KOLContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.KOLToken);
            //var AirdropContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.AirdropToken);
            var LiquidityContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.LiquidityToken);
            var TeamFundContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.TeamFundToken);
            var EcoFundContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.EcoFundToken);
            var InvestmentContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.InvestmentToken);
            var NodeContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.NodeReleaseToken);
            //var MiningContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.MiningToken);
            var StakingContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.StakingToken);

            // await KOLContract.methods.userIsRelease(address).call({from:address}).then(function(result){
            //     if(result){
            //         await KOLContract.methods.totalAmount().call({from:address}).then(function(result){
            //             that.KOLTotal = web3.utils.fromWei(result,'ether')
            //         })
            //         await KOLContract.methods.getReward(address).call({from:address}).then(function(result){
            //             that.KOLWaitWD = web3.utils.fromWei(result,'ether')
            //             that.KOLWaitWD = Number(that.KOLWaitWD).toFixed(4)
            //         })
            //         await KOLContract.methods.userWDReward(address).call({from:address}).then(function(result){
            //             that.KOLWD = web3.utils.fromWei(result,'ether')
            //             that.KOLWD = Number(that.KOLWD).toFixed(4)
            //         })
            //     }
            // })
            const isKOLRelease = await KOLContract.methods.userIsRelease(address).call({ from: address });
            if (isKOLRelease) {
                const totalAmount = await KOLContract.methods.totalAmount().call({ from: address });
                that.KOLTotal =Number(Number(web3.utils.fromWei(totalAmount, 'ether')).toFixed(2));

                const reward = await KOLContract.methods.getReward(address).call({ from: address });
                that.KOLWaitWD = Number(Number(web3.utils.fromWei(reward, 'ether')).toFixed(2));

                const wdReward = await KOLContract.methods.userWDReward(address).call({ from: address });
                that.KOLWD = Number(Number(web3.utils.fromWei(wdReward, 'ether')).toFixed(2));
            }

            // const isAirdropRelease = await AirdropContract.methods.userIsRelease(address).call({ from: address });
            // if (isAirdropRelease) {
            //     const totalAmount = await AirdropContract.methods.totalAmount().call({ from: address });
            //     that.AirdropTotal =Number(Number(web3.utils.fromWei(totalAmount, 'ether')).toFixed(2));

            //     const reward = await AirdropContract.methods.getReward(address).call({ from: address });
            //     that.AirdropWaitWD = Number(Number(web3.utils.fromWei(reward, 'ether')).toFixed(2));

            //     const wdReward = await AirdropContract.methods.userWDReward(address).call({ from: address });
            //     that.AirdropWD = Number(Number(web3.utils.fromWei(wdReward, 'ether')).toFixed(2));
            // }

            const isLiquidityRelease = await LiquidityContract.methods.userIsRelease(address).call({ from: address });
            if (isLiquidityRelease) {
                const totalAmount = await LiquidityContract.methods.totalAmount().call({ from: address });
                that.LiquidityTotal =Number(Number(web3.utils.fromWei(totalAmount, 'ether')).toFixed(2));

                const reward = await LiquidityContract.methods.getReward(address).call({ from: address });
                that.LiquidityWaitWD = Number(Number(web3.utils.fromWei(reward, 'ether')).toFixed(2));

                const wdReward = await LiquidityContract.methods.userWDReward(address).call({ from: address });
                that.LiquidityWD = Number(Number(web3.utils.fromWei(wdReward, 'ether')).toFixed(2));
            }


            const isTeamFundRelease = await TeamFundContract.methods.userIsRelease(address).call({ from: address });
            if (isTeamFundRelease) {
                const totalAmount = await TeamFundContract.methods.totalAmount().call({ from: address });
                that.TeamFundTotal =Number(Number(web3.utils.fromWei(totalAmount, 'ether')).toFixed(2));

                const reward = await TeamFundContract.methods.getReward(address).call({ from: address });
                that.TeamFundWaitWD = Number(Number(web3.utils.fromWei(reward, 'ether')).toFixed(2));

                const wdReward = await TeamFundContract.methods.userWDReward(address).call({ from: address });
                that.TeamFundWD = Number(Number(web3.utils.fromWei(wdReward, 'ether')).toFixed(2));
            }

            const isEcoFundRelease = await EcoFundContract.methods.userIsRelease(address).call({ from: address });
            if (isEcoFundRelease) {
                const totalAmount = await EcoFundContract.methods.totalAmount().call({ from: address });
                that.EcoFundTotal =Number(Number(web3.utils.fromWei(totalAmount, 'ether')).toFixed(2));

                const reward = await EcoFundContract.methods.getReward(address).call({ from: address });
                that.EcoFundWaitWD = Number(Number(web3.utils.fromWei(reward, 'ether')).toFixed(2));

                const wdReward = await EcoFundContract.methods.userWDReward(address).call({ from: address });
                that.EcoFundWD = Number(Number(web3.utils.fromWei(wdReward, 'ether')).toFixed(2));
            }

            const isInvestmentRelease = await InvestmentContract.methods.userIsRelease(address).call({ from: address });
            if (isInvestmentRelease) {
                const totalAmount = await InvestmentContract.methods.totalAmount().call({ from: address });
                that.InvestmentTotal =Number(Number(web3.utils.fromWei(totalAmount, 'ether')).toFixed(2));

                const reward = await InvestmentContract.methods.getReward(address).call({ from: address });
                that.InvestmentWaitWD = Number(Number(web3.utils.fromWei(reward, 'ether')).toFixed(2));

                const wdReward = await InvestmentContract.methods.userWDReward(address).call({ from: address });
                that.InvestmentWD = Number(Number(web3.utils.fromWei(wdReward, 'ether')).toFixed(2));
            }

            const isNodeRelease = await NodeContract.methods.userIsRelease(address).call({ from: address });
            if (isNodeRelease) {
                const totalAmount = await NodeContract.methods.totalAmount().call({ from: address });
                that.NodeTotal =Number(Number(web3.utils.fromWei(totalAmount, 'ether')).toFixed(2));

                const reward = await NodeContract.methods.getReward(address).call({ from: address });
                that.NodeWaitWD = Number(Number(web3.utils.fromWei(reward, 'ether')).toFixed(2));

                const wdReward = await NodeContract.methods.userWDReward(address).call({ from: address });
                that.NodeWD = Number(Number(web3.utils.fromWei(wdReward, 'ether')).toFixed(2));
            }

            // const isMiningRelease = await MiningContract.methods.userIsRelease(address).call({ from: address });
            // if (isMiningRelease) {
            //     const totalAmount = await MiningContract.methods.totalAmount().call({ from: address });
            //     that.MiningTotal =Number(Number(web3.utils.fromWei(totalAmount, 'ether')).toFixed(2));

            //     const reward = await MiningContract.methods.getReward(address).call({ from: address });
            //     that.MiningWaitWD = Number(Number(web3.utils.fromWei(reward, 'ether')).toFixed(2));

            //     const wdReward = await MiningContract.methods.userWDReward(address).call({ from: address });
            //     that.MiningWD = Number(Number(web3.utils.fromWei(wdReward, 'ether')).toFixed(2));
            // }

            const isStakingRelease = await StakingContract.methods.userIsRelease(address).call({ from: address });
            if (isStakingRelease) {
                const totalAmount = await StakingContract.methods.totalAmount().call({ from: address });
                that.StakingTotal =Number(Number(web3.utils.fromWei(totalAmount, 'ether')).toFixed(2));

                const reward = await StakingContract.methods.getReward(address).call({ from: address });
                that.StakingWaitWD = Number(Number(web3.utils.fromWei(reward, 'ether')).toFixed(2));

                const wdReward = await StakingContract.methods.userWDReward(address).call({ from: address });
                that.StakingWD = Number(Number(web3.utils.fromWei(wdReward, 'ether')).toFixed(2));
            }
       
        }

    },
    mounted() {
        let timer = setInterval(async () => {
            if (true) {
                this.getInfo()
                clearInterval(timer)
            }
        }, 500);
    },
};
</script>

<style lang="less" scoped>
.node {
    width: 375px;
    //overflow-x: hidden;
    position: relative;
    //overflow-y: auto;
    //height: 100%;
    //min-height: 100%;
    background-size: 100% 800px;
    padding: 0 16px 42px;
    background: url("../../assets/img/home/header-bg.png") no-repeat;
    background-size: 471.9px 240.62px;
    background-position: -60px -97px;
    flex: 1;

    &-bg {
        width: 637.18px;
        position: absolute;
        height: 294px;
        top: -92px;
        left: 50%;
        transform: translateX(-50%);
        background: url('../../assets/img/node/bg.png') no-repeat center;
        background-size: 100% 100%;
    }

    .placeholder {
        height: 34px;
    }

    .px15 {
        padding: 0 15px;
    }

    .node-swipe {
        margin-top: 24px;

        .swipe {
            border-radius: 16px;

            .swipe-item {
                background: url('../../assets/img/node/swipe-bg.png') no-repeat;
                background-size: 100% 100%;
                padding: 1px;
            }
        }
    }

    .tags {
        margin-top: 32px;
        display: flex;
        font-size: 16px;
        line-height: 16px;

        >div {
            opacity: 0.5;
            margin-right: 24px;

            &.active {
                font-weight: bold;
                opacity: 1;
            }
        }
    }


    .card {
        margin-top: 16px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        border-radius: 16px;
        padding: 1px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            display: flex;
            justify-content: space-between;
            padding: 14px 12px;
        }


        &-l {
            height: 88px;
            width: 88px;
            border-radius: 8px;
            background: url('../../assets/img/home/icon-bg.png')no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;

        }

        &-r {
            margin-left: 12px;
            flex: 1;
            padding-top: 8px;
            padding-bottom: 2px;
            display: flex;
            color: #FFFFFF;

            &-l {
                flex: 1;
                font-size: 16px;
                line-height: 16px;

                >div {
                    margin-bottom: 15px;
                }

                &-b {
                    margin-top: 19px;
                    line-height: 12px;
                    font-weight: 500;
                    font-size: 12px;
                    opacity: 0.6;
                    margin-bottom: 0 !important;
                }
            }

            &-r {
                padding: 2px 0;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;

                .text {
                    font-size: 12px;
                    line-height: 12px;
                    font-weight: 500;
                       max-width: 120px;
                    text-align: right;
                    span {
                        background-image: -webkit-linear-gradient(134deg, #0DF1D5 2%, #0190D1 98%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                }

                .btn {
                    width: 76px;
                    height: 32px;
                    cursor: pointer;
                    border-radius: 8px;
                    font-size: 14px;
                    display: flex;
                    color: #000000;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(112deg, #0DF1D5 0%, #0190D1 97%);
                }
            }
        }
    }

    .empty {
        padding-top: 64px;
        display: flex;
        flex-direction: column;
        align-items: center;

        >img {
            width: 160px;
            height: 160px;
        }

        >div {
            margin-top: 27px;
            line-height: 14px;
            font-size: 14px;
            height: 32px;
            font-weight: 500;
            border-radius: 8px;
            padding: 0 12px;
            display: flex;
            align-items: center;
            color: #000000;
            background: linear-gradient(101deg, #0DF1D5 0%, #0190D1 97%);
        }
    }

    .card1 {
        height: 156px;
        border-radius: 16px;
        background: #FFFCF5;
        margin-top: 16px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            padding: 16px;
        }

        &-title {
            font-size: 16px;
            line-height: 16px;
            margin-bottom: 16px;
        }

        &-content {
            >div {
                display: flex;

                >div {
                    flex: 1;

                    .label {
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 16px;
                        margin-bottom: 6px;
                    }

                    .value {
                        line-height: 12px;
                        font-size: 12px;
                        opacity: 0.6;
                    }

                    .btn {
                        color: #000000;
                        height: 32px;
                        border-radius: 8px;
                        cursor: pointer;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        width: 76px;
                        background: linear-gradient(112deg, #0DF1D5 0%, #0190D1 97%);
                    }
                }

            }

            >div+div {
                margin-top: 20px;
            }
        }
    }

    .release {
        border-radius: 16px;
        background: #FFFCF5;
        margin-top: 16px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            padding: 0 16px;

            >div+div {
                border-top: 1px solid #2A2A2A;
            }

            .release-item {
                padding: 16px 0;

                >div {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .title {
                        font-size: 14px;
                        line-height: 14px;
                    }

                    .num {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        font-weight: bold;
                        color: #05B9D0;

                        >img {
                            width: 16px;
                            height: 16px;
                            margin-left: 8px;
                        }
                    }

                    .time {
                        margin-top: 8px;
                        font-size: 12px;
                        line-height: 14px;
                        opacity: 0.6;
                    }
                }
            }

            .more {
                text-align: center;
                padding: 16px 0;
                opacity: 0.6;
                line-height: 14px;
                font-size: 12px;

            }
        }
    }

    .release1 {
        .num {
            font-weight: 500 !important;

        }
    }
}
</style>
<style lang="less">
.node {
    .node-swipe {
        .swipe .van-swipe-item {
            color: #fff;
            font-size: 20px;
            height: 160px;
            text-align: center;
        }
    }
    .van-swipe__indicators {
        right: 12px;
        bottom: 12px;
        left: auto;
    }
}

.revenue-popup {
    padding: 32px 20px 40px;
    border: 1px solid rgba(255, 255, 255, 0.5);

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    >.label {
        margin-top: 20px;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 16px;
    }

    >.ipt {
        height: 48px;
        background: #16151D;
        border-radius: 16px;
        display: flex;
        align-items: center;

        .van-cell {
            background: transparent;

            .van-field__control {
                font-weight: 500;
                font-size: 14px;
                color: #FFFFFF;
            }
        }

        .aux {
            color: #FFFFFF;
            font-size: 14px;
        }
    }

    >.text {
        margin-top: 12px;
        text-align: right;
        font-size: 14px;

        span {
            color: #05B9D0;
            margin-left: 16px;
        }
    }

    >.desc {
        margin-top: 20px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        border-radius: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            border-radius: 16px;
            padding: 16px;

            >div+div {
                margin-top: 16px;
            }

            >div {
                display: flex;
                justify-content: space-between;

                .label {
                    opacity: 0.6;
                    font-size: 14px;
                    letter-spacing: -0.25px;
                }

                .value {
                    letter-spacing: -0.25px;
                    font-size: 14px;
                }
            }
        }
    }

    >.btn {
        background: url('../../assets/img/node/btn.png') no-repeat;
        background-size: 100% 100%;
        border-radius: 16px;
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        height: 48px;
        color: #000000;
        margin-top: 36px;
    }
}

.revenue-loading,
.subscription-loading {
    padding: 32px 20px 80px;

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    >.loading {
        padding-top: 64px;
        display: flex;
        height: 100px;
        justify-content: center;

        @keyframes ball-spin-fade-loader {
            50% {
                opacity: 0.3;
                -webkit-transform: scale(0.4);
                transform: scale(0.4);
            }

            100% {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1);
            }
        }

        .ball-spin-fade-loader {
            position: relative;
            margin-left: -15px;
        }

        .ball-spin-fade-loader>div:nth-child(1) {
            top: 25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0s infinite linear;
            animation: ball-spin-fade-loader 1s 0s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(2) {
            top: 17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.12s infinite linear;
            animation: ball-spin-fade-loader 1s 0.12s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(3) {
            top: 0;
            left: 25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.24s infinite linear;
            animation: ball-spin-fade-loader 1s 0.24s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(4) {
            top: -17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.36s infinite linear;
            animation: ball-spin-fade-loader 1s 0.36s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(5) {
            top: -25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0.48s infinite linear;
            animation: ball-spin-fade-loader 1s 0.48s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(6) {
            top: -17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.6s infinite linear;
            animation: ball-spin-fade-loader 1s 0.6s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(7) {
            top: 0;
            left: -25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.72s infinite linear;
            animation: ball-spin-fade-loader 1s 0.72s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(8) {
            top: 17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.84s infinite linear;
            animation: ball-spin-fade-loader 1s 0.84s infinite linear;
        }

        .ball-spin-fade-loader>div {
            background: linear-gradient(133deg, #0DF1D5 2%, #0190D1 98%);
            width: 15px;
            height: 15px;
            border-radius: 100%;
            margin: 2px;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
            position: absolute;
        }
    }

    >.desc {
        margin-top: 16px;
        text-align: center;
        letter-spacing: -0.25px;
        font-size: 14px;
        opacity: 0.6;
    }
}

.revenue-claim,
.subscription-claim {
    padding: 32px 20px 80px;
    backdrop-filter: blur(46px);
    border-top: 1px solid rgba(255, 255, 255, 0.5);

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    .claim-ok {
        padding-top: 48px;

        >img {
            width: 120px;
            height: 120px;
            margin: 0 auto;
        }

        >.title {
            font-size: 18px;
            margin-top: 16px;
            text-align: center;
            letter-spacing: -0.25px;
        }

        >.desc {
            font-size: 14px;
            margin-top: 8px;
            letter-spacing: -0.25px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                opacity: 0.6;

            }

            img {
                width: 16px;
                height: 16px;
                margin-left: 7px;
            }
        }
    }

}
</style>